export enum SetCode {
  DELINTERVALMIN = "DELINTERVALMIN",
  PICKINTERVALMIN = "PICKINTERVALMIN",
  REFNOLABEL = "REFNOLABEL",
  DIREQTBLNO = "DI_REQTBLNO",
  DITBLNOLBL = "DI_TBLNOLBL",
  DPPARENTIMG = "DPPARENTIMG",
  FILTERCOLORSET = "FILTERCOLORSET",
  STOREMENULAYOUT = "STOREMENULAYOUT",
  KTIPREPMINS = "KTIPREPMINS",
  SHARETABLE = "SHARETABLE",
  WHATAPP_BTN = "WHATAPP_BTN",
  STO_ODR_REMARK = "STO_ODR_REMARK",
  C_WHATAPP_BTN = "C_WHATAPP_BTN",
  HIDEBLOCKEDITEM = "HIDEBLOCKEDITEM",
  HIDEASAP = "HIDEASAP",
  SHOWQRORDERNO = "SHOWQRORDERNO",
  CUTLERYLABEL = "CUTLERYLABEL",
  DI_ENASTOBBTN = "DI_ENASTOBBTN",
  ENASTOBACKBTN = "ENASTOBACKBTN",
  OT_DINE_LBL = "OT_DINE_LBL",
  OT_PICKUP_LBL = "OT_PICKUP_LBL",
  HIDEODRREMARK = "HIDEODRREMARK",
  QRORDERNOMSG = "QRORDERNOMSG",
  DI_NOREQLOGIN = "DI_NOREQLOGIN",
  PI_NOREQLOGIN = "PI_NOREQLOGIN",
  DE_NOREQLOGIN = "DE_NOREQLOGIN",
  QUE_DISABLE_ORDER = "QUE_DISABLE_ORDER",
  ShowOrderTypePopup = "ShowOrderTypePopup",
  CAPCUSTINFO = "CAPCUSTINFO",
  CUSTREQINFO = "CUSTREQINFO",
  STO_TNC = "STO_TNC",
  LOGINMETHOD = 'LOGINMETHOD',
  ISITMCHBLSRC = "ISITMCHBLSRC",
  HIDERATING = "HIDERATING",
  STOREALERTFLAG = "STOREALERTFLAG",
  CHILDITEMLAYOUT = "CHILDITEMLAYOUT",
  EINVACTIVEFLAG = "EinvActiveFlag",
  REQUIREDAMT = "REQUIREDAMT",
  INTGMODE = "INTGMODE",
  OFFLINEBLKMODE = "OFFLINEBLKMODE",
  EISNGLEBILL = "EISNGLEBILL",
  CARTSHOWPROMOSC = "CARTSHOWPROMOSC"
}
